/**
 * This is the main page for creating a new studio listing.
 * As this is a complex component, it'll be designed with the following way:
 *   * The page will be divided into steps, each step will be a component
 *   * We will design this around the MVC pattern with the following:
 *   *     Each step component will be a view, and will be responsible for rendering the UI
 *   *     Each step component will also have controller functions to handle user input
 *   *     This top level component will be the controller for moving between steps and
 *   *         and will make sure it can move to appropriate steps, or handle any errors
 *   *     Data will be modelled through Contexts and Reducers
 */

import React from 'react'
import PageLayout from '../../layout/page_layout'
import { useNavigate } from 'react-router-dom'
import StudioListingFormWizard, { StudioListingContentInput } from '../../components/studio_listing_form_wizard'
import { StudioService } from '../../apilibrary'
import { trackStudioCreation } from '../../utils/analytics'
import { IStudio } from '../../apilibrary/types/studio'

const CreateStudioListingPage: React.FC = () => {
  const navigate = useNavigate()
  let studio: IStudio

  const handleCreateStudio = async (input: StudioListingContentInput): Promise<void> => {
    console.log(input)
    studio = await StudioService.createStudio(input)
    await trackStudioCreation(studio.id, studio.ownerId);
    navigate(`/studio/${studio.id}`)
  }

  return (
    <PageLayout addGutter authOnly>
      <StudioListingFormWizard
        formTitle='Create Studio Listing'
        onClickSave={handleCreateStudio}
        saveButtonLabel='Create Studio'
        />
    </PageLayout>
  )
}

export default CreateStudioListingPage
